//import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
import moment from 'moment';
//import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
//import './components/fontawesome/fontawesome';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';

//import './css/index.css';
//import './css/header.css';

export default class SupportEmail extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			
			emails: [],
      show: false,
		};
		this.showEmail = this.showEmail.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', {data: 'no value'});

		//this.getWebsites();

		

		//this.setState({status: true});
		this.getMail();
		
		

	}

	componentWillUnmount() {
	}

	async getMail() {
		let params = new URLSearchParams();
		const x = await postApi('/v3/support/email/outbox', params);
		//console.log(x.data);
		this.setState({status: true, emails: x.data.emails?x.data.emails:[]});
	}

  async showEmail(id) {
    if( id !== this.state.show ) {
			
			let emails = this.state.emails;

			let params = new URLSearchParams();
			params.append('id', emails[id].id);
			const x = await postApi('/v3/support/email/outboxbody', params);
			//console.log(x.data);

			emails[id].content = x.data.content;
      
			this.setState({show: id, emails});
    } else {
      this.setState({show: false});
    }
  }

	async resend(id, sender) {
		//console.log(id, sender);
		let params = new URLSearchParams();
		params.append('email', id);
		params.append('sender', sender);
		await putApi('/v3/support/email/send', params);
	}

	render() {

		const emails = this.state.emails.map((e,i) => {
			return (
        <React.Fragment key={i}>
          <tr>
            <th scope="row" onClick={()=>this.showEmail(i)}>
              <div className="d-flex align-items-center">
                <span className="avatar avatar-xs me-2 online avatar-rounded">
                  <img src={`https://cloud.ultrastream.io${e.avatar}`} alt="img" />
                </span>
                {e.title?e.title:e.username}
              </div>
            </th>
            <td onClick={()=>this.showEmail(i)}>
              {moment(new Date(e.date)).format("L  LT")}
            </td>
            <td onClick={()=>this.showEmail(i)}>{e.email}</td>
            <td onClick={()=>this.showEmail(i)}>{e.subject}</td>
            <td>
              <Dropdown>
								<Dropdown.Toggle variant="success" id="dropdown-basic" size="sm">
									Resend
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item onClick={()=>this.resend(e.id, 0)}>To Owner</Dropdown.Item>
									<Dropdown.Item onClick={()=>this.resend(e.id, 1)}>To Myself</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
            </td>
          </tr>
          {this.state.show === i &&
            <tr>
              <td colSpan={5}>
								<div style={{position: 'relative'}}>
									<Row className="gx-0">
										<Col md={5} style={{display: 'inline-block', wordWrap: 'break-word', whiteSpace: 'pre-line'}}>
											<div style={{textDecoration: 'underline', marginBottom: 10}}>Text Version:</div>
											<span>{e.plain}</span>
										</Col>
										<Col md={7}>
											<div style={{textDecoration: 'underline', marginBottom: 10}}>HTML Version:</div>
											<iframe src={`data:text/html,${encodeURIComponent(e.content)}`} width="100%" frameBorder="0" scrolling="auto" style={{height: '75vh'}} title="Email Details" />
										</Col>
									</Row>
                </div>
              </td>
            </tr>
          }
        </React.Fragment>
      )
    });
		
		return (
			<>

				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Email</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								{/*<li className="breadcrumb-item"><a href="javascript:void(0);">Ui Elements</a></li>*/}
								<li className="breadcrumb-item active" aria-current="page">Email</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.status &&
					<div className="main-content app-content">
						 
						<div className="container-fluid">

							<div className="my-4">
								<Row>
									
									<Col xs={12}>
										<div className="row row-cols-xxl-5 row-cols-xl-3 row-cols-md-2">
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Sales</p>
																<h3 className="mb-0">$18,645</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-primary-transparent ms-auto">
																<i className="bi bi-cart-check fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-primary-transparent rounded-pill">+24% <i className="fe fe-arrow-down"></i></span>
															<span className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</span>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Revenue</p>
																<h3 className="mb-0">$34,876</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-secondary-transparent ms-auto">
																<i className="bi bi-archive fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-success-transparent rounded-pill">+0.26% <i className="fe fe-arrow-down"></i></span>
															<span className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</span>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium text-muted mb-1">Total Products</p>
																<h3 className="mb-0">26,231</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-info-transparent ms-auto">
																<i className="bi bi-handbag fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-danger-transparent rounded-pill">+06% <i className="fe fe-arrow-down"></i></span>
															<span className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</span>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Expenses</p>
																<h3 className="mb-0">$73,579</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-warning-transparent ms-auto">
																<i className="bi bi-currency-dollar fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-success-transparent rounded-pill">+10% <i className="fe fe-arrow-up"></i></span>
															<span className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</span>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium text-muted mb-1">Active Subscribers</p>
																<h3 className="mb-0">1,468</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-danger-transparent ms-auto">
																<i className="bi bi-bell fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-danger-transparent rounded-pill">+16% <i className="fe fe-arrow-down"></i></span>
															<span className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</Col>

									<Col xs={12}>
										<div className="card custom-card overflow-hidden">
											<div className="card-header flex-between justify-content-between">
												<div className="card-title">System Email</div>
											</div>
                      <div className="card-body">
                        <table className="table text-nowrap table-bordered">
                          <thead>
                            <tr>
                              <th scope="col">User</th>
                              <th scope="col">Date</th>
                              <th scope="col">Email</th>
                              <th scope="col">Subject</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {emails}
                          </tbody>
                        </table>
                      </div>
										</div>
									</Col>
								</Row>
							</div>
						</div>
					</div>
				}
			</>
		);
	}
}
